'use strict';

import * as moment from 'moment';

(function () {
  angular
    .module('specsguardApp')
    .controller('AccountActivateCtrl', AccountActivateCtrl);

  AccountActivateCtrl.$inject = ['$scope', '$stateParams', '$location', '$interval',
    '$sce', '$log', 'Auth', 'Labels', '$state', 'errorMessageService', 'User'];

  function AccountActivateCtrl ($scope, $stateParams, $location, $interval,
    $sce, $log, Auth, Labels, $state, errorMessageService, User) {

    $scope.errors = {};
    $scope.redirectSeconds = 3;

    $scope.data = {
      message: '',
      messageIsError: false
    };

    $scope.tokenIsActive = true;

    $scope.LABELS = Labels;

    if ($stateParams.activationToken && $stateParams.userId) {
      User.getUserById({_id: $stateParams.userId}).$promise.then((usr) => {
        const daysBetweenDates = calculateDaysBetween(usr.lastActviationMail);

        if (daysBetweenDates >= 14) {
          $scope.tokenIsActive = false;
        }
      });
    }

    $scope.redirectAfter = function (count, route) {
      const countdown = $interval(function () {
        $scope.data.message = $sce.trustAsHtml(
          $scope.LABELS.getLabel('changedpassword') + '<br/>' +
          $scope.LABELS.getLabel('redirectlogin') + ':<br/>' +
          $scope.redirectSeconds + ' ' + $scope.LABELS.getPlural('second') + '...'
        );

        if ($scope.redirectSeconds === 0) {
          $location.path(route);
          $interval.cancel(countdown);
        } else {
          $scope.redirectSeconds--;
        }
      }, 1000, count + 1, true);
    };

    $scope.activateUser = function (form) {
      $scope.submitted = true;
      if (form.$valid) {
        $log.debug('form valid, submitting...');
        Auth.activateUser($stateParams.userId, $stateParams.activationToken, $scope.user.newPassword)
          .then(function (res) {
            if (res.status === 'fail') {
              throw new Error(res.error && res.error.msg);
            }

            const msg = $scope.LABELS.getLabel('changedpassword');
            errorMessageService.showToast(msg, true);
            $scope.redirectAfter($scope.redirectSeconds, '/login');
          })
          .catch(function (reason) {
            if (reason.status === 400) {
              form.newPassword.$setValidity('mongoose', false);
            }
          });
      }
    };

    $scope.passwordObj = () => {
      $scope.user = {
        newPassword: ''
      };
    };

    $scope.passwordObj();

    $scope.$on('validPassword', (evt, data) => {
      if (data.value) {
        $scope.user.newPassword = data.value;
      }
    });

    $scope.$on('resetPassword', (evt) => {
      $scope.passwordObj();
    });


    /**
     * Calculate the days between the currentDate & last time the activation e-mail was sent
     *
     * @param originalDate Date is based on the lastActivationMail property
     */
    function calculateDaysBetween(originalDate) {
      const oldDate = moment(originalDate);
      const currentDate = moment();
      const duration = moment.duration(currentDate.diff(oldDate));
      return Math.ceil(duration.asDays());
    }
  }
})();
